import { Turbo } from "@hotwired/turbo-rails";
import QRScannerController from "@fire/bridge/qr_scanner_controller";

// walk/WELCOME.md, the scanner. Fire's bridge opens the camera and hands back
// what it read; fire's own next step posts that to a scan list, and here the
// read is only an address. So it goes through the door the paste field uses
// (GET /ballots/scan?code=) and Turbo takes the page from there.
export default class extends QRScannerController {
  handleQrData(value) {
    // The camera keeps reading until somebody closes it: the first read is the visit.
    if (this.visited) return;
    this.visited = true;
    this.send("scanCallback", { result: true });
    // The native camera is continuous: it closes when the page says so.
    this.send("dismiss");
    Turbo.visit(`${this.endpointValue}?code=${encodeURIComponent(value)}`);
  }
}
